<template>
  <ModalLayout icon="upload-slim" title="Upload files" @close="close">
    <UploadFiles
      v-model="creativeFiles"
      :validate="true"
      :options="{
        limit: 100,
        accept: ['image/jpeg', 'image/png', 'image/gif', 'video/mp4', 'video/x-msvideo', 'video/avi', 'video/x-matroska'],
      }"
      @remove="removeFile"
    >
      <template slot="tip">JPG/JPEG/PNG/MP4/AVI/ files with a size less than 5mb per file</template>
    </UploadFiles>

    <template slot="footer">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button
        @click="ctaUpload"
        class="font-semibold ml-0"
        icon="el-icon-upload2"
        type="primary"
        :loading="loading"
        :disabled="!creativeFiles.length || loading"
        >Upload</el-button
      >
    </template>
  </ModalLayout>
</template>
<script>
import ModalLayout from '../ModalLayout.vue'
import UploadFiles from '../../parts/UploadFiles.vue'

export default {
  name: 'UploadCreatives',
  components: { ModalLayout, UploadFiles },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      creativeFiles: [],
    }
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    async ctaUpload() {
      if (!this.creativeFiles.length) return

      this.loading = true
      try {
        await this.$store.dispatch('socialBoostCampaign/addCreativeFiles', {
          creative_id: this.meta.creative_id,
          files: this.creativeFiles,
        })

        this.$Modal.instance.isOpen = false
      } catch (e) {
        this.$message.error('Upload failed. Please try again.')
      } finally {
        this.loading = false
      }
    },
    removeFile(file) {
      if (file?.id) {
        console.log('Removing file:', file, this.creativeFiles)
      }
    },
  },
}
</script>
